import React from "react";
import { Menu, LogOut, Clock3 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getRoleLabel, initials } from "../lib/utils";

export const Header = ({ onMenuClick, title, subtitle }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="app-header">
      <div className="flex w-full items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuClick}
            className="lg:hidden rounded-xl border border-[#E2E8F0] bg-white p-2 text-[#475569]"
            aria-label="Open navigation"
          >
            <Menu size={20} />
          </button>
          <div>
            <h1 className="font-['Manrope'] text-lg font-semibold tracking-tight text-[#0F172A]">
              {title}
            </h1>
            {subtitle && <p className="hidden text-sm text-[#64748B] sm:block">{subtitle}</p>}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="hidden items-center gap-2 rounded-full border border-[#E2E8F0] bg-white px-3 py-2 text-sm text-[#64748B] md:flex">
            <Clock3 size={14} />
            <span>{new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}</span>
          </div>

          <div className="hidden items-center gap-3 rounded-2xl border border-[#E2E8F0] bg-white px-3 py-2 sm:flex">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#163D6B] text-sm font-semibold text-white">
              {initials(user?.name)}
            </div>
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-[#0F172A]">{user?.name}</p>
              <p className="truncate text-xs text-[#64748B]">{getRoleLabel(user?.role)}</p>
            </div>
          </div>

          <button
            onClick={handleLogout}
            className="inline-flex items-center gap-2 rounded-xl border border-[#E2E8F0] bg-white px-3 py-2 text-sm font-medium text-[#0F172A] transition hover:border-[#163D6B] hover:text-[#163D6B]"
          >
            <LogOut size={16} />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
